import { translate } from "src/services";
import { Container, Page, TextDisplay, Video, Wrapper } from "src/styled";

import errorVideo from "src/assets/videos/error.mp4";

const ErrorPage = () => {
  return (
    <Page>
      <Container>
        <Wrapper margin="no auto" textAlign="center" maxWidth="400px">
          <Video src={errorVideo} autoPlay datatype="video/mp4" loop muted />
        </Wrapper>
        <TextDisplay
          margin="large"
          size="extraLarge"
          weight="medium"
          block
          align="center"
        >
          {translate("alertMessages.oops")}
        </TextDisplay>
        <TextDisplay margin="large" size="xxLarge" block align="center">
          {translate("alertMessages.generalError")}
        </TextDisplay>
      </Container>
    </Page>
  );
};

export default ErrorPage;
